import { useDispatch, useSelector } from 'react-redux';
import likeImage from '../../assets/like.svg';
import unlikeImage from '../../assets/unlike.svg';
import {
  updateVideo,
  updateVideoUnlike,
} from '../../features/video/videoSlice';

export default function LikeUnlike() {
  const { video } = useSelector((state) => state.video);

  const dispatch = useDispatch();
  const handleAddLike = () => {
    dispatch(updateVideo(video));
  };
  const handleAddUnLike = () => {
    dispatch(updateVideoUnlike(video));
  };
  return (
    <div className="flex gap-10 w-48">
      <div className="flex gap-1">
        <div onClick={handleAddLike} className="shrink-0">
          <img className="w-5 block" src={likeImage} alt="Like" />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">
          {video.likes}
        </div>
      </div>
      <div onClick={handleAddUnLike} className="flex gap-1">
        <div className="shrink-0">
          <img className="w-5 block" src={unlikeImage} alt="Unlike" />
        </div>
        <div className="text-sm leading-[1.7142857] text-slate-600">
          {video.unlikes}
        </div>
      </div>
    </div>
  );
}
